import { render, staticRenderFns } from "./account-plan-message-modal.vue?vue&type=template&id=58004cc2"
import script from "./account-plan-message-modal.vue?vue&type=script&lang=js"
export * from "./account-plan-message-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports